import { forwardRef, memo, useCallback, useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Autocomplete from '@shared/components/autocomplete/Autocomplete';
import classNames from 'classnames';
import { TextField } from '@shared/views/form-dialog';
import ProductEnvironmentList from '@pages/ai-product/background-step/ProductEnvironmentList';

const useStyles = makeStyles({
  textFieldRoot: {
    height: '42px',
    width: '180px',
    "& > div.MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      height: '42px',
      paddingRight: '50px !important',
      '& > input': {
        height: '42px',
      },
    },
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& > img': {
      width: '40px',
      height: '40px',
    },
  },
  valueSelected: {
    '& > div > .MuiOutlinedInput-notchedOutline': {
      borderColor: '#00C98F',
    },
    '& > div > input': {
      color: '#00C98F',
    },
  },
});


const EnvironmentTextField = forwardRef(({
  name,
  label,
  onChange,
  value,
  group,
}, ref) => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState(null);

  const handleChange = useCallback((_, data) => {
    if (data && data.name) {
      onChange(data);
    } else {
      const option = options.find((op) => op.name === data);
      if (option) {
        onChange(option);
        return;
      }
      if (value === data) {
        return;
      }
      onChange(defaultValue);
    }
  }, [onChange, options, name, value, defaultValue]);

  useEffect(() => {
    const generalGroup = ProductEnvironmentList.find((item) => item.group === 'General');
    const otherGroup = ProductEnvironmentList.find((item) => item.group === group) || {
      children: [],
    };
    const options = [...otherGroup.children, ...generalGroup.children];
    setOptions(options);
    if (value?.group !== group && value?.group !== 'General') {
      onChange(options[0]);
    }
  }, [group]);

  const hasValue = !!value;

  return (
    <Autocomplete
      options={ options }
      disableClearable
      getOptionLabel={ (option) => option.name }
      getOptionSelected={ (option) => option.name === value?.name }
      onChange={ handleChange }
      onBlur={ (e) => handleChange(e, e.target.value) }
      ref={ ref }
      value={ value || defaultValue }
      renderInput={ (params) => (
        <TextField
          { ...params }
          classes={ {
            root: classNames(classes.textFieldRoot, {
              [classes.valueSelected]: hasValue,
            }),
          } }
          label={ label }
          variant="outlined"
          InputProps={ {
            ...params.InputProps,
          } }
        />
      ) }
    />
  );
});

export default memo(EnvironmentTextField);
